import { createSelector } from 'reselect';

import { reduxFormSelectors } from '~/utils';
import { envConfigSelectors } from '~/components';

const { selectYourDetails } = reduxFormSelectors;

const {
  selectAppointmentForSomeoneElseQuestionIds,
  selectAttendeeNameQuestionIds,
  selectAttendeePhoneQuestionIds,
  selectGiftAppointmentQuestionIds,
} = envConfigSelectors;

export const selectUserDetails = createSelector(
  selectYourDetails,
  ({ firstName = '', lastName = '', email = '', phoneNumber = '' } = {}) => ({
    name: `${firstName} ${lastName}`.trim(),
    email,
    phone: phoneNumber,
  }),
);

export const selectAttendeeDetails = createSelector(
  selectYourDetails,
  selectAttendeeNameQuestionIds,
  selectAttendeePhoneQuestionIds,
  (
    yourDetails = {},
    [primaryQuestionIdOfAttendeeName, secondaryQuestionIdOfAttendeeName],
    [primaryQuestionIdOfAttendeePhone, secondaryQuestionIdOfAttendeePhone],
  ) => {
    const name =
      yourDetails[primaryQuestionIdOfAttendeeName] ||
      yourDetails[secondaryQuestionIdOfAttendeeName];
    const phone =
      yourDetails[primaryQuestionIdOfAttendeePhone] ||
      yourDetails[secondaryQuestionIdOfAttendeePhone];
    return {
      name: name ? name[0] : '',
      phone: phone ? phone[0] : '',
    };
  },
);

export const selectAppointmentForSomeoneElseAnswer = createSelector(
  selectYourDetails,
  selectAppointmentForSomeoneElseQuestionIds,
  (yourDetails = {}, isAppointmentForSomeoneElseQuestionIds) =>
    isAppointmentForSomeoneElseQuestionIds.some((questionId) => {
      const answer = yourDetails[questionId];

      return answer && answer[0];
    }),
);

export const selectAppointmentGiftAnswer = createSelector(
  selectYourDetails,
  selectGiftAppointmentQuestionIds,
  (yourDetails = {}, isAppointmentGiftQuestionIds) =>
    isAppointmentGiftQuestionIds.some((questionId) => {
      const answer = yourDetails[questionId];
      return answer && !!answer[0];
    }),
);
